import settingsModule from '../../settings.module';
import template from './userProvisioning.component.html';
import style from './userProvisioning.component.css';

export default settingsModule.component('userProvisioning', {
    template,
    style,
    controller(__env) {
        const vm = this;
        var userProvisioningURL = new URL("/signin/#!/login?returnUrl=%2Fconsole%2F%23!%2Fusers%2Fsettings%2Fuserprovisioning", __env.cloudUrl);
        vm.userProvisioningURL = userProvisioningURL.toString();
    }
});



// WEBPACK FOOTER //
// ./modules/settings/components/userProvisioning/userProvisioning.component.js